export default __webpack_public_path__ + "static/bg1200-85eed93b9373aa984e84045218e72065.png";